<template>
    <div class="main">
        <Steps :index="1" product-name="投标保证金保险" />
        <ApplicantCompanyInfo :info="info" title="投保企业信息" />
        <InvoiceInfo :info="info.invoiceInfo" v-if="info.invoiceInfo" />
        <div class="mt15 agree">
    	<Checkbox v-model="agree">我已经阅读并同意</Checkbox>
        <a href="/static/pdf/haierProduct/投标履约特约.pdf" target="_blank">《投标履约特约》</a>
        <a href="/static/pdf/haierProduct/阳光财产保险股份有限公司投标履约保证保险（2023版）条款.pdf" target="_blank">《阳光财产保险股份有限公司投标履约保证保险（2023版）条款》</a>
    </div>
        <div class="mt20 center">
            <p>实际支付：<span class="price">{{info.premium}}元</span></p>
            <p class="mt10">
                <Button type="primary" @click="toPay" :disabled="!agree"  :loading="loading">提交</Button>
            </p>
        </div>   
    </div>
</template>
<script>
    import RecognizeInfo from './RecognizeInfo'
    import ApplicantCompanyInfo from './common/ApplicantCompanyInfo'
    import InvoiceInfo from './common/InvoiceInfo'
    import Steps from '../common/Steps'
    import track from "@/mixin/track";
    export default {
        mixins:[ track ],
        components: { RecognizeInfo, ApplicantCompanyInfo, InvoiceInfo, Steps },
        data () {
            return {
                info: {
                    id: this.$route.params.id,
                },
                loading: false,
                agree: false,
                id: this.$route.params.id
            }
        },
        created () {
            if (this.id) {
                this.getInfo()
            }
        },
        mounted () {
            // 回溯 开始录制
            this.$nextTick(this.startRecord);
        },
        methods: {
            // 根据id获取信息
            getInfo () {
                this.$axios.post('/broker/insurance/application/detail', {
                    applicationId: this.id
                }).then(res => {
                    this.info = res;
                });
            },
            async toPay () {
                this.loading = true;
                this.$axios.post('/broker/insurance/application/confirm', {
                    applicationId: this.id
                }).then(async res => {
                    this.loading = false;
                    if(res){
                        // 回溯 停止录制
                        await this.stopRecord({
                            policy_id:this.info.applicationNo
                        });
                        this.toast('提交成功')
                        window.location.href=`/common.html#/common-pay/${res}`;
                    } else {
                        this.$axios.post('/broker/insurance/application/detail', {
                            applicationId: this.id
                        }).then(response => {
                            if(response.applicationStatus=='REVIEWED_REJECTED'){
                                this.$Notice.error({
                                    title: '提示',
                                    desc: response.remark
                                });
                            }
                        });
                    }
                }).catch(err=>{
                    this.loading = false;
                })
            }
        }
    }
</script>
<style scoped lang="less">
    .main {
        background: #fff;
        margin-top: 15px;
        padding: 30px 40px;
    }

    .mt20 {
        font-size: 25px;
        line-height: 1.8;
    }

    span.price {
        color: #FF0000;
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/customizedEmployerLiability/ConfirmCompany.vue